﻿$.fn.dxCtrlGridComDestinataireTrackingVueSms = function custom_dxCtrlGridComDestinataireTrackingVueSms(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridcomdestinatairetrackingvuesms dx-ctrl");
        this.createInstance(new cdxCtrlGridComDestinataireTrackingVueSms(this, option));
    }
    return this;
}

window.cdxCtrlGridComDestinataireTrackingVueSms = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridtrackingvuesms"

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun tracking vue sms",
            typeData: "trackingvuesms",
            lstTypeGrille: ["Lignes"],
            lstLstConditionBase: option.lstLstConditionBase,
            context_grid: option.context_grid,
            getItemTemplateHeight: function (typeGrille) { return 35 },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche le mail
                    option.bddCtrl.getObjet("com_sms_envoi", dataTemplate.com_sms_envoi.id_com_sms_envoi).mShowPopup()
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            itemsToolbar: mGetLstButtonToolBar(),
            itemsToolbarSelect: mGetLstButtonToolBarSelect,
            //onShowHideCheck: function (showed) {
            //    if (showed) {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").show()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").show()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").show()
            //    } else {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").hide()
            //    }
            //},
            onSelectionChanged: function () {
                //if (dxBtAddDossier) {
                //    dxBtAddDossier.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddDossier.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtAddPipeline) {
                //    dxBtAddPipeline.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddPipeline.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtDonwload) {
                //    dxBtDonwload.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtDonwload.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged()
            },
            onDisplayButtonLigne: mGetLstButtonLigne,
            onEndClickDataGrid: option.onEndClickDataGrid,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: option.allowCheck,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        itemTemplateGrilleClickVue(contentElement, dataTemplate, type, dxGrid, { bddCtrl: option.bddCtrl, showCom: option.showVoirDoc, showStrcon: true })
        //var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;text-align:left;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $TdUtiTrack = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //$("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgStrConUti({
        //    bddCtrl: option.bddCtrl,
        //    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
        //    id: dataTemplate.com_email_envoi.id_utilisateur,
        //    text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com_email_envoi.id_utilisateur).mGetLib1()
        //})
        //var $TdAdresseEmail = $("<td style='width:20%;max-width:150px;padding:0 5px;font-family:barlow condensed;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' title='" + dataTemplate.com_destinataire.adresse_email + "'><u>" + dataTemplate.com_destinataire.adresse_email.reduit(20) + "</u></td>").appendTo($Tr)
        //var $TdCom = $("<td style='padding:0 5px;width:40%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-style:italic;' class='state-hover2'/>").appendTo($Tr)
        //$TdCom.text(dataTemplate.com_email_envoi.objet)
        //$TdCom.attr("title", "Afficher l'email<br/>" + dataTemplate.com_email_envoi.objet)
        //$TdCom.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet("com_email_envoi", dataTemplate.com_email_envoi.id_com_email_envoi).mShowPopup() })

        //var $TdStrCon = $("<td style='padding:0 5px;width:40%;'/>").appendTo($Tr)
        //if (typeof dataTemplate.strcon == "undefined") {
        //    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email</span>")
        //} else {
        //    $TdStrCon.addClass('state-hover2')
        //    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        //    var obj = option.bddCtrl.getObjet(table.nom)
        //    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
        //    var $Tr = $("<tr/>").appendTo($Table)
        //    var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //    obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
        //    var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
        //    $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgStrConUti({
        //        bddCtrl: option.bddCtrl,
        //        idTable: table.id_table,
        //        id: dataTemplate.strcon.id_key,
        //        text: ""
        //    })
        //    var $TdLib = $("<td style='width:100%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
        //    $TdLib.text(obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
        //    $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
        //    $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        //}
        ////var $Table = $("<table style='width:100%;height:100%;'/>").appendTo(contentElement)
        ////var $Tr = $("<tr/>").appendTo($Table)
        ////var $TdStrCon = $("<td style='width:100%;text-align:left;'/>").appendTo($Tr)
        ////var $TdUtiTrack = $("<td style='width:30px;padding:0 3px;'/>").appendTo($Tr)
        ////$("<div style='width:24px;height:24px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgStrConUti({
        ////    bddCtrl: option.bddCtrl,
        ////    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
        ////    id: dataTemplate.com_sms_envoi.id_utilisateur,
        ////    text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com_sms_envoi.id_utilisateur).mGetLib1()
        ////})
        ////var tel = new cTelephone(dataTemplate.com_destinataire.tel_code_pays, dataTemplate.com_destinataire.tel_sms)
        ////var $TdAdresseEmail = $("<td style='width:1px;padding:0 3px;white-space:nowrap;font-family:barlow condensed;'><u>" + tel.mGetValueMiseEnForme() + "</u></td>").appendTo($Tr).attr("title", tel.mGetValueMiseEnForme())

        ////if (typeof dataTemplate.strcon == "undefined") {
        ////    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour le numéro de téléphone</span>")
        ////} else {
        ////    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        ////    var obj = option.bddCtrl.getObjet(table.nom)
        ////    obj.itemTemplateGrille($TdStrCon, dataTemplate.strcon, type)
        ////}
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        $("<span title='" + dataTemplate.track.dcr.toFrenchDateTime() + "'><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.track.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)

        //var $Span = $("<span style='font-family:barlow condensed;font-size:120%;'></span>").appendTo(contentElement)
        //var $ADoc = null

        //if (option.showVoirDoc) {
        //    if (typeof dataTemplate.com_sms_envoi != 'undefined') {
        //        $ADoc = $("<a href='javascript:void(0)'>Voir SMS</a>").appendTo($Span)
        //        $ADoc.on("click", function (e) {
        //            e.stopPropagation()
        //            option.bddCtrl.getObjet("com_sms_envoi", dataTemplate.com_sms_envoi.id_com_sms_envoi).mShowPopup()
        //        })
        //    }
        //    $("<span> &bull; </span>").appendTo($Span)
        //}


        ////if (dataGrid.passe2 == "0") $("<span> &bull; CLICK ROBOT &bull; </span>").appendTo($Span)
        ////var $span = $("<span style='font-family:barlow condensed;font-size:120%;'>" + ((dataGrid.libelle != dataGrid.lien) ? "(" + dataGrid.libelle + ") " : "") + "</span>").appendTo(contentElement)
        ////var $A = $("<a href='javascript:void(0)'>" + dataGrid.lien.decoupe(20) + "</a>").appendTo($span)
        ////$A.on("click", function (e) {
        ////    e.stopPropagation()
        ////    window.open(dataGrid.lien, "_blank")
        ////})
        //$("<span>Vue " + dataTemplate.com_sms_envoi_tracking_vue.dcr.toDateIlya(false) + " (" + dataTemplate.com_sms_envoi_tracking_vue.dcr.toFrenchDateTime() + ")</span>").appendTo($Span)
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date vue",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Vue: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }])

        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + ((txt.length == 0) ? "(Aucun utilisateur)" : txt) + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "id_com_sms_envoi",
            dataField: "id_com_sms_envoi",
            caption: "id_com_sms_envoi",
            icon: "fas fa-plus",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "body_txt",
            dataField: "body_txt",
            caption: "texte du sms",
            icon: "fas fa-heading",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>text SMS: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "adresse_email",
            dataField: "adresse_email",
            caption: "Destinataire",
            icon: "fas fa-user",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: false,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Destinataire: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []
        if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-comment-sms",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouveau SMS",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_sms_envoi").objetMetier.mShowNewSms()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-file",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            icon3: "fas fa-at",
            //            colorIcone3: theme.color,
            //            leftIcone3: true,
            //            txtTooltip: "Nouveau document email",
            //            onClick: function (e) {
            //                (new cObjetFichierEmlzMetier(null, bdd)).mShowNewDocumentEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
        }
        //if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {

        //    if (option.bddCtrl.objCptCli.objetMetier.hasDossier()) {
        //        items.push({
        //            location: 'before',
        //            template: function (itemData, itemIndex, itemElement) {
        //                itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
        //                option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement,function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
        //            }
        //        })
        //        //items.push(option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null"))
        //    }
        //    if (option.bddCtrl.objCptCli.objetMetier.hasPipeline()) {
        //        items.push({
        //            location: 'before',
        //            template: function (itemData, itemIndex, itemElement) {
        //                itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
        //                option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement,function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
        //            }
        //        })
        //        //items.push(option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null"))
        //    }
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            dxBtDonwload = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-cloud-arrow-up",
        //                txtTooltip: "Exporter la liste des contacts qui ont vues",
        //                onClick: function (e) {
        //                    var lstDataTraitement = dxGrid.mGetLstSelectedData()
        //                    if (lstDataTraitement.length == 0) lstDataTraitement = dxGrid.mGetLstData()
        //                    if (lstDataTraitement.length == 0) {
        //                        mNotify("Aucune donnée à exporter.", "warning", 6000)
        //                    } else {
        //                        jaugeDemarrage.mShow()
        //                        var lstIdTableId = []
        //                        lstDataTraitement.forEach(function (data) {
        //                            lstIdTableId.push({ id: data.id })
        //                        })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "exportstrconvuesms",
        //                            data: lstDataTraitement
        //                        }, function (data) {
        //                            if (data.urlfile.startsWith("~")) data.urlfile = data.urlfile.substring(1)
        //                            window.open(data.urlfile)
        //                            jaugeDemarrage.mHide()
        //                            mNotify("Votre exportation est fini. Le fichier est en cours de téléchargement.", "success", 6000)
        //                        })
        //                    }
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        //return items
    }

    //var dxBtAddDossier = null
    //var dxBtAddPipeline = null
    //var dxBtDonwload = null
    function mGetLstButtonToolBarSelect(dxVirtualGrid) {
        var items = []
        var itemToolbar = {
            location: 'before',
            visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
            template: function (itemData, itemIndex, itemElement) {
                var dxBtAfficheGrilleStrCon = $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des vues",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxVirtualGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            option.bddCtrl.mAjaxCall({ command: "getdataslstsmsvue", lstid: xlstIdTableId }, function (data) {
                                data.lstsmsvue = JSON.parse(data.lstsmsvue)
                                //if (typeof data.lstsmsvue == 'undefined') data.lstsmsvue = []
                                if (data.lstsmsvue.length > 0) {
                                    page.mAddPopupLst("Liste des vues sms" + ((typeof option.objet == 'undefined') ? "" : " &bull; " + option.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lstsmsvue
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                    }
                }).dxCtrlButton("instance")
                dxVirtualGrid.lstButtonForCheck.push(dxBtAfficheGrilleStrCon)
            }
        }
        dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
        items.push(itemToolbar)


        if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {


            //if (option.bddCtrl.objCptCli.objetMetier.hasDossier()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddDossier = option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //            if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddDossier) window.setTimeout(function () { dxBtAddDossier.element().closest(".dx-toolbar-button").hide() }, 0)
            //            dxVirtualGrid.lstButtonForCheck.push(dxBtAddDossier)
            //        }
            //    })
            //}
            //if (option.bddCtrl.objCptCli.objetMetier.hasPipeline()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddPipeline = option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_vue inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_vue.id_com_sms_envoi_tracking_vue=tab.id INNER JOIN com_destinataire ON comsms_envoi_tracking_vue.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //            if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddPipeline) window.setTimeout(function () { dxBtAddPipeline.element().closest(".dx-toolbar-button").hide() }, 0)
            //            dxVirtualGrid.lstButtonForCheck.push(dxBtAddPipeline)
            //        }
            //    })
            //}
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        var dxBtDonwload = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-cloud-arrow-up",
            //            txtTooltip: "Exporter la liste des contacts qui ont vues",
            //            onClick: function (e) {
            //                var lstDataTraitement = dxVirtualGrid.mGetLstSelectedData()
            //                if (lstDataTraitement.length == 0) lstDataTraitement = dxVirtualGrid.mGetLstData()
            //                if (lstDataTraitement.length == 0) {
            //                    mNotify("Aucune donnée à exporter.", "warning", 6000)
            //                } else {
            //                    jaugeDemarrage.mShow()
            //                    var lstIdTableId = []
            //                    lstDataTraitement.forEach(function (data) {
            //                        lstIdTableId.push({ id: data.id })
            //                    })
            //                    option.bddCtrl.mAjaxCall({
            //                        command: "exportstrconvuesms",
            //                        data: lstDataTraitement
            //                    }, function (data) {
            //                        if (data.urlfile.startsWith("~")) data.urlfile = data.urlfile.substring(1)
            //                        window.open(data.urlfile)
            //                        jaugeDemarrage.mHide()
            //                        mNotify("Votre exportation est fini. Le fichier est en cours de téléchargement.", "success", 6000)
            //                    })
            //                }
            //            }
            //        }).dxCtrlButton("instance")
            //        if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtDonwload) window.setTimeout(function () { dxBtDonwload.element().closest(".dx-toolbar-button").hide() }, 0)
            //        dxVirtualGrid.lstButtonForCheck.push(dxBtDonwload)
            //    }
            //})
        }
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}